<template>
    <vProjectFooter
        :project="ticker"
        :canSkipGenerator="!onboardState.isLoading"
        :actions="dotsMenuActions"
        :hasChanges="hasChanges"
        :isCreatorShown="isCreatorShown"
        @save="saveSnapshot"
        @publish="$emit('publish')"
        @skipGenerator="toggleCreatorShown(false)"
    />
</template>

<script>
import { mapState, mapActions } from "vuex";
import vProjectFooter from "@/shared/views/vProjectFooter.vue";
import { storeToRefs } from "pinia";
import { useTickerCreatorStore } from "@/apps/ticker/project/onboarding/ticker-creator.store";

export default {
    name: "TickerProjectFooter",
    components: {
        vProjectFooter,
    },
    emits: ["publish"],
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        const tickerCreatorStore = useTickerCreatorStore();
        const { isCreatorShown, onboardState } = storeToRefs(tickerCreatorStore);
        const { toggleCreatorShown } = tickerCreatorStore;
        return { isCreatorShown, onboardState, toggleCreatorShown };
    },
    computed: {
        ...mapState("ticker", ["ticker", "hasChanges"]),
        dotsMenuActions() {
            return this.isCreatorShown ? [] : this.actions;
        },
    },
    methods: {
        ...mapActions("ticker", ["saveSnapshot"]),
    },
};
</script>
